import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/src/stylus/app.styl';
import hu from 'vuetify/es5/locale/hu';

Vue.use(Vuetify, {
  theme: {
    primary: '#d1ae68',
    secondary: '#e69997',
  },
  iconfont: 'md',
  lang: {
    locales: { hu },
    current: 'hu',
  },
});
